/**
 * カラコン商品一覧の画像種別をストアに保持し、 localStorage に永続化する
 * @see https://github.com/Everforth/growthpalette-front/issues/8656
 */
import { ImageAppKind } from '@/models/api/image'
import { localStorageKeys } from '@/registry/local-storage-keys'
import { Module } from 'vuex'

export type ContactLensImageType = 'worn' | 'lens' | 'package'

export const DEFAULT_IMAGE_TYPE: ContactLensImageType = 'package'

const STORAGE_KEY = localStorageKeys.contactLensImageType

const IMAGE_APP_KIND_MAP: Record<ContactLensImageType, string> = {
  worn: ImageAppKind.WornForListView,
  lens: ImageAppKind.Lens,
  package: ImageAppKind.Representative,
}

function loadFromStorage(): ContactLensImageType {
  try {
    const v = localStorage.getItem(STORAGE_KEY)

    // 予期しない値が入っている場合はデフォルトのパッケージ画にフォールバック
    return (v === 'worn' || v === 'lens' || v === 'package') ? v : DEFAULT_IMAGE_TYPE
  } catch {
    // localStorage が利用不可の場合はデフォルトのパッケージ画にフォールバック
    return DEFAULT_IMAGE_TYPE
  }
}

export function createContactLensImageType<R>(): Module<{ imageType: ContactLensImageType }, R> {
  return {
    namespaced: true,
    state: { imageType: loadFromStorage() },
    mutations: {
      setImageType(state, type: ContactLensImageType) {
        state.imageType = type
        try {
          localStorage.setItem(STORAGE_KEY, type)
        } catch {
          // localStorage が利用不可の場合は無視
        }
      },
    },
    getters: {
      imageAppKind: (state): string => IMAGE_APP_KIND_MAP[state.imageType] || ImageAppKind.WornForListView,
    },
  }
}
